import { motion } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, heading, sub, dark = false }) => (
  <div className="mb-14 md:mb-20 max-w-4xl">
    <Reveal>
      <p
        className={`flex items-center gap-3 text-xs font-medium uppercase tracking-[0.22em] ${
          dark ? "text-[#F7F5F0]/60" : "text-[#4A4A4A]"
        }`}
      >
        <span className="inline-block h-[2px] w-8 bg-[#C42021]" aria-hidden="true" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        className={`mt-6 font-display leading-[1.05] tracking-[-0.02em] h-section ${
          dark ? "text-[#F7F5F0]" : "text-[#171717]"
        }`}
      >
        {heading}
      </h2>
    </Reveal>
    {sub ? (
      <Reveal delay={0.16}>
        <p className={`mt-6 max-w-2xl text-base md:text-lg leading-relaxed ${dark ? "text-[#B8B8B8]" : "text-[#4A4A4A]"}`}>
          {sub}
        </p>
      </Reveal>
    ) : null}
  </div>
);
